export const BRACKY_ANIMATION_URLS = {
  default: "https://a.bracky.app/icons/bracky-animated-88.gif",
  winkInitial: "https://a.bracky.app/icons/bracky-animated-thinking-3d-wink-2.gif",
  sideEye: "https://a.bracky.app/icons/bracky-animated-side-eye.gif",
  doubleNod: "https://a.bracky.app/icons/bracky-animated-double-nod-3.gif",
  wink3D: "https://a.bracky.app/icons/bracky-animated-thinking-3d-wink-fast.gif",
  shocked: "https://a.bracky.app/icons/bracky-animated-shocked-2.gif",
  lookRight: "https://a.bracky.app/icons/bracky-animated-look-right.gif",
  wincePressed: "https://a.bracky.app/icons/bracky-animated-wince-low-2.gif",
  winceHover: "https://a.bracky.app/icons/bracky-animated-wince.gif",
} as const
